import axios, { type AxiosInstance, type AxiosRequestHeaders } from 'axios'

function getCSRFToken() {
  const tokenEl = document.querySelector<HTMLMetaElement>('[name="csrf-token"]')
  if (tokenEl) {
    return tokenEl.content
  }
  return null
}

// Cache the token in memory so we don’t query the DOM on every request
const csrfToken = getCSRFToken()

const api: AxiosInstance = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

api.interceptors.request.use((config) => {
  const method = (config.method ?? 'get').toUpperCase()
  const needsCsrf = !['GET', 'HEAD', 'OPTIONS'].includes(method)

  const headers = config.headers as Record<string, string>

  // Default content type for JSON bodies
  if (!headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  if (needsCsrf && csrfToken) {
    headers['X-CSRF-Token'] = csrfToken
  }

  config.headers = headers as AxiosRequestHeaders
  return config
})

export default api
